<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from 'axios';
/**
 * Advanced table component
 */
export default {
  page: {
    title: "BALANCE SHEET",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "BALANCE SHEET",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "BALANCE SHEET",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },        
        {
          key: "account",
          sortable: true,
          label: "PARTICULARS",
        },
        {
          key: "dr",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "cr",
          sortable: true,
          label: "AMOUNT",
        }
      ],
      
      // make inputs required
      accountError: "",
      amountError: "",
      // delete category
      deletedata: {
        name: "",
        id: "",
      },
      total_credit:0,
      total_debit:0,

      filterData: {
        date: moment(new Date()).format("YYYY-MM-DD"),
        branch_id:0
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("coa", ["BalanceSheet","filterStatus"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.BalanceSheet ? this.BalanceSheet.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.BalanceSheet ? this.BalanceSheet.length : 1;
  },
  // updated(){
  // },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStatement: "coa/fetchBalancesheet"
    }),
    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    resetErrors() {
        this.acountError = "";
        this.amountError = "";
    },
    
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    FetchBalancesheet(){
      this.FetchStatement(this.filterData);
    },

    Excel_export() {
      axios
        .post("export_bs", this.filterData,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "balance_sheet.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
  },

  created() {
    this.FetchStatement(this.filterData);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row" style="font-size: medium;">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <h3 class="card-title mb-2 text-center">BALANCE SHEET AS OF {{filterData.date}} </h3>
            </div> 
            <div class="row">    
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div> 
              <div class="col-md-3">
                <label>FILTER AS OF</label>
                <input type="date"
                  class="form-control"
                  v-model="filterData.date"
                  lang="en"
                  @keyup.enter="setLabel(), FetchTransactions()"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 mt-4" align="right">
                <button class="btn btn-warning" type="button" @click="FetchBalancesheet()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-if="BalanceSheet">
              <table class="table-responsive mb-0 table" align="center">
                <thead>
                  <tr>
                    <th><h4>Particulars</h4></th>
                    <th><h4>Amounts</h4></th>
                    <th><h4>Amounts</h4></th>
                  </tr>                  
                </thead>
                <tbody>
                  <tr v-if="BalanceSheet.currentassets.length > 0 || BalanceSheet.fixedassets.length > 0">
                    <td></td>
                    <td><h4>Assets</h4></td>
                    <td></td>
                  </tr>  
                  <tr v-if="BalanceSheet.currentassets.length > 0">
                    <td></td>
                    <td><h5><b>Current Assets</b></h5></td>
                    <td></td>
                  </tr>                  
                  <tr v-for="(item, index) in BalanceSheet.currentassets" :key="index">
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ item.accounts.name }}</td>
                    <td v-else>{{ item.accounts.name }}</td>
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                    <td v-else>{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                  </tr>
                  <tr v-if="BalanceSheet.fixedassets.length > 0">
                    <td></td>
                    <td><h5><b>Fixed Assets</b></h5></td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, index) in BalanceSheet.fixedassets" :key="index">
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ item.accounts.name }}</td>
                    <td v-else>{{ item.accounts.name }}</td>
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                    <td v-else>{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                  </tr>

                  <tr v-if="BalanceSheet.currentassets.length > 0 || BalanceSheet.fixedassets.length > 0">
                    <td><b>Total Assets</b></td>
                    <td></td>
                    <td><b>{{ BalanceSheet.totalassets?BalanceSheet.totalassets.toLocaleString():0 }}</b></td>
                  </tr>

                  <tr v-if="BalanceSheet.equity.length > 0 || BalanceSheet.reserves>0">
                    <td></td>
                    <td><h4>Equity</h4></td>
                    <td></td>
                  </tr>                  
                  <tr v-for="(item, index) in BalanceSheet.equity" :key="index">
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ item.accounts.name }}</td>
                    <td v-else>{{ item.accounts.name }}</td>
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                    <td v-else>{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                  </tr>
                  <tr v-if="BalanceSheet.reserves>0">
                    <td>Retained Earnings</td>
                    <td>{{ BalanceSheet.reserves?BalanceSheet.reserves.toLocaleString():0 }}</td>
                  </tr>
                  <tr v-if="BalanceSheet.equity.length > 0">
                    <td><b>Total Equity</b></td>
                    <td></td>
                    <td><b>{{ BalanceSheet.totalequity?BalanceSheet.totalequity.toLocaleString():0 }}</b></td>
                  </tr>
                  <tr v-if="BalanceSheet.currentliabilities.length > 0 || BalanceSheet.longliabilities.length > 0">
                    <td></td>
                    <td><h4>Liabilities</h4></td>
                    <td></td>
                  </tr> 
                  <tr v-if="BalanceSheet.currentliabilities.length > 0">
                    <td></td>
                    <td><h5><b>Current Liabilities</b></h5></td>
                    <td></td>
                  </tr>                  
                  <tr v-for="(item, index) in BalanceSheet.currentliabilities" :key="index">
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ item.accounts.name }}</td>
                    <td v-else>{{ item.accounts.name }}</td>
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                    <td v-else>{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                  </tr>
                  <tr v-if="BalanceSheet.longliabilities.length > 0">
                    <td></td>
                    <td><h5><b>Long-term Liabilities</b></h5></td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, index) in BalanceSheet.longliabilities" :key="index">
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ item.accounts.name }}</td>
                    <td v-else>{{ item.accounts.name }}</td>
                    <td class="text-danger" v-if="parseInt(item.amount)<0">{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                    <td v-else>{{ parseInt(item.amount)?parseInt(item.amount).toLocaleString():0 }}</td>
                  </tr>
                  <tr v-if="BalanceSheet.currentliabilities.length > 0 || BalanceSheet.longliabilities.length > 0">
                    <td><b>Total Liabilities</b></td>
                    <td></td>
                    <td><b>{{ BalanceSheet.totalliabities?BalanceSheet.totalliabities.toLocaleString():0 }}</b></td>
                  </tr>
                  <tr v-if="BalanceSheet.currentliabilities.length || BalanceSheet.longliabilities.length || BalanceSheet.totalequity">
                    <td><b>Total Liabilities and Equity</b></td>
                    <td></td>
                    <td><b>{{ BalanceSheet.totalliabities || BalanceSheet.totalequity?(BalanceSheet.totalliabities+BalanceSheet.totalequity).toLocaleString():0 }}</b></td>
                  </tr>
                  <tr v-else>
                    <td></td>
                    <td style="text-align: center;">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Loader v-if="!BalanceSheet"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
